/* Product page: show the selected variant's photo straight away.
   The theme normally waits for the server to send a fresh page (about a second) before the gallery changes.
   Here the matching photo that is already in the gallery is selected the moment a variant is chosen, and the
   gallery's other photos are loaded in the background so there is nothing to wait for. */

const readVariants = () => {
  const data = document.querySelector('script[data-st-variant-media]');
  if (!data) return [];
  try {
    return JSON.parse(data.textContent);
  } catch (error) {
    return [];
  }
};

const preload = () => {
  document.querySelectorAll('media-gallery img[loading="lazy"]').forEach((img) => {
    img.loading = 'eager';
    img.decoding = 'async';
  });
};

const selectedOptions = (picker) =>
  Array.from(picker.querySelectorAll('input[type="radio"]:checked, select')).map((field) => field.value);

const showVariantPhoto = (picker) => {
  const wanted = selectedOptions(picker);
  const match = readVariants().find((variant) => variant.o.length === wanted.length && variant.o.every((value, index) => value === wanted[index]));
  if (!match || !match.m) return;

  const gallery = document.querySelector('media-gallery');
  const slides = gallery ? Array.from(gallery.querySelectorAll('slideshow-slide')) : [];
  const index = slides.findIndex((slide) => slide.querySelector(`[data-media-id="${match.m}"]`));
  if (index < 0 || !gallery.slideshow) return;
  gallery.slideshow.select(index, undefined, { animate: false });
};

document.addEventListener('change', (event) => {
  const picker = event.target.closest?.('variant-picker');
  if (picker) showVariantPhoto(picker);
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preload);
else preload();
window.addEventListener('load', preload);